<template>
  <div class="public-player page">
    <AppHeader close_button>{{$root.texts.free_audios.media[num_audio].title}}</AppHeader>
    <div class="public-player__content">
      <div class="public-player__header">
        <img src="../assets/head_phones_white.svg">
        <div class="public-player__titlenum">
          <h3>{{$root.texts.free_audios.media[num_audio].num}}</h3>
          <span>{{$root.texts.free_audios.media[num_audio].title}}</span>
        </div>
        <img src="../assets/line_grey.svg">
      </div>
      <div class="public-player-container">
        <AudioPlayer
          :img="getPublicURL($root.texts.free_audios.media[num_audio].image)"
          :src="getPublicURL($root.texts.free_audios.media[num_audio].audio)"
        ></AudioPlayer>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import AppHeader from "@/components/AppHeader.vue";
import AudioPlayer from "@/components/AudioPlayer.vue";

export default {
  name: "public",
  props: {
    num_audio: Number
  },
  data() {
    return {
      requesturi: "./"
    };
  },
  methods: {
    getPublicURL: function(url) {
      return this.requesturi + url;
    }
  },
  components: {
    AppHeader,
    AudioPlayer
  }
};
</script>